import { Box, Button, Dialog, Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { CrossIcon, InfoIconSVG } from '../../../assets/customIcons';
var TechPackPopup = function (_ref) {
    var open = _ref.open, onClose = _ref.onClose, heading = _ref.heading, description = _ref.description, popupType = _ref.popupType, declineButton = _ref.declineButton, acceptButton = _ref.acceptButton;
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var colors = {
        white: '#FFFFFF',
        primary: '#007AFF',
        warning: '#FFAB00',
        warningLight: '#FFEECC',
        infoLight: '#D7EAFF',
        border: '#DEE4EB',
        text: {
            primary: '#101828',
            secondary: '#8593A3'
        }
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "xs",
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: '12px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: popupType === 'info' ? colors.infoLight : colors.warningLight,
            borderRadius: '50%',
            width: '48px',
            height: '48px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ml: IS_MOBILE ? 3 : 4,
            mt: IS_MOBILE ? 3 : 4
        }
    }, /*#__PURE__*/ React.createElement(InfoIconSVG, {
        sx: {
            color: popupType === 'info' ? colors.primary : colors.warning,
            fontSize: '24px',
            rotate: popupType === 'warning' ? '180deg' : '0deg'
        }
    })), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onClose,
        sx: {
            p: 1.5,
            mr: IS_MOBILE ? 2 : 3,
            mt: 1
        }
    }, /*#__PURE__*/ React.createElement(CrossIcon, {
        sx: {
            color: colors.text.secondary,
            fontSize: '14px'
        }
    }))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            px: IS_MOBILE ? 3 : 4,
            pb: IS_MOBILE ? 3 : 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '18px',
            fontWeight: 600,
            lineHeight: '28px',
            color: colors.text.primary,
            textAlign: 'left',
            mt: 3
        }
    }, heading), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            color: colors.text.secondary,
            textAlign: 'left',
            mt: 1
        }
    }, description)), /*#__PURE__*/ React.createElement(Grid, {
        mt: 1,
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: IS_MOBILE ? 'column' : 'row',
        flexDirection: IS_MOBILE ? 'column' : 'row-reverse',
        justifyContent: 'end',
        spacing: 1,
        sx: {
            p: IS_MOBILE ? 3 : 4,
            pt: 0
        }
    }, acceptButton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.9,
        sm: acceptButton.fullWidth ? 12 : 2.5
    }, /*#__PURE__*/ React.createElement(Button, {
        fullWidth: acceptButton.fullWidth,
        variant: acceptButton.type,
        sx: {
            borderRadius: '8px',
            backgroundColor: colors.primary,
            color: colors.white,
            height: '40px',
            width: acceptButton.fullWidth || IS_MOBILE ? '100%' : '70px'
        },
        onClick: acceptButton.onClick
    }, acceptButton.text)), declineButton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.8,
        sm: 2.5
    }, /*#__PURE__*/ React.createElement(Button, {
        fullWidth: declineButton.fullWidth,
        variant: declineButton.type,
        sx: {
            borderRadius: '8px',
            borderColor: colors.border,
            color: colors.text.secondary,
            mr: 2,
            height: '40px',
            width: IS_MOBILE ? '100%' : '70px'
        },
        onClick: declineButton.onClick
    }, declineButton.text)))));
};
export default TechPackPopup;
